module.exports = __webpack_public_path__ + "static/img/brees-2009-slide-8.8044eec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2009-slide-8.jpg
// module id = reKi
// module chunks = 1